module.exports = __webpack_public_path__ + "img/1080_27.28413eb5.jpg";